import { provide, inject, ref, type InjectionKey, type Ref } from 'vue'

type SalaryPeriod = 'hourly' | 'biweekly' | 'monthly' | 'annually' | 'weekly'
export interface GlobalSalaryPeriodState {
  activePeriod: Ref<SalaryPeriod>
  displayPeriods: Record<SalaryPeriod, string>
  changePeriod: (period: string) => void
  adjustValueForPeriod: (value: number) => number
}
const SALARY_PERIOD_KEY = Symbol(
  'salary-period'
) as InjectionKey<GlobalSalaryPeriodState>
const createDefaultState = () => {
  const activePeriod = ref<SalaryPeriod>('hourly')
  const displayPeriods = {
    hourly: 'hour',
    biweekly: '2 weeks',
    weekly: '1 week',
    monthly: 'month',
    annually: 'year'
  }
  function changePeriod(period: string) {
    activePeriod.value = period as SalaryPeriod
  }
  function adjustValueForPeriod(value: number): number {
    if (!value) return 0
    if (activePeriod.value === 'hourly') {
      return value / 2080
    } else if (activePeriod.value === 'biweekly') {
      return value / 26
    } else if (activePeriod.value === 'monthly') {
      return value / 12
    } else if (activePeriod.value === 'weekly') {
      return value / (26 * 2)
    }
    return value
  }
  return {
    activePeriod,
    displayPeriods,
    changePeriod,
    adjustValueForPeriod
  }
}

export function provideGlobalSalaryPeriod() {
  const state = createDefaultState()
  provide(SALARY_PERIOD_KEY, state)
  return state
}

export function useGlobalSalaryPeriod(): GlobalSalaryPeriodState {
  const state = inject(SALARY_PERIOD_KEY, null)
  if (state) {
    return state
  }
  return createDefaultState()
}
